import { parseISO } from 'date-fns';
import { useToggle } from 'react-use';
import { MdOutlineCalendarToday } from 'react-icons/md';
import { CalendarDate, parseDate } from '@internationalized/date';
import { Button, Calendar, Popover, PopoverContent, PopoverTrigger } from '@ds';
import { formatDate } from '@/utils/helpers';

type ScheduleDateControlProps = {
  value: Date;
  onChange: (date: Date) => void;
};

export const ScheduleDateControl = ({ value, onChange }: ScheduleDateControlProps) => {
  const [isOpen, toggleOpen] = useToggle(false);

  const handleDateSelect = (date: CalendarDate) => {
    onChange(parseISO(date.toString()));
    toggleOpen(false);
  };

  return (
    <Popover placement="bottom" isOpen={isOpen} onOpenChange={toggleOpen}>
      <PopoverTrigger>
        <Button size="md" variant="light" disableRipple className="rounded-lg bg-base-50">
          <span className="text-m-r">{formatDate(value, 'EEE, d MMM yyyy')}</span>
          <MdOutlineCalendarToday size={20} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="p-0">
        <Calendar
          aria-label="Select Date"
          value={parseDate(formatDate(value, 'yyyy-MM-dd'))}
          onChange={handleDateSelect}
        />
      </PopoverContent>
    </Popover>
  );
};
